import React from 'react';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-navy-deep pt-16 pb-8 border-t border-white/10" data-id="element-70">
      <div className="container mx-auto px-4 md:px-6" data-id="element-71">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 mb-16" data-id="element-72">
          {/* Brand Col */}
          <div className="lg:col-span-2" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/4WLNA9mVcANNEqY541rLKv/WhatsApp_Image_2026-05-20_at_13.32.06.jpg" alt="Global Remote Logo" className="h-12 w-auto object-contain mb-6 bg-white p-2 rounded" data-id="element-74" />
            <p className="text-white/70 text-sm mb-6 max-w-sm" data-id="element-75">
              Helping local businesses get found, trusted, and chosen. More
              reviews, more calls, more customers.
            </p>
            
            <div className="flex gap-4" data-id="element-76">
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-77">
                <Facebook size={20} data-id="element-78" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-79">
                <Instagram size={20} data-id="element-80" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-81">
                <Twitter size={20} data-id="element-82" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-83">
                <Linkedin size={20} data-id="element-84" />
              </a>
            </div>
          </div>

          {/* Links Cols */}
          <div data-id="element-85">
            <h4 className="text-white font-heading font-bold mb-4" data-id="element-86">Services</h4>
            <ul className="space-y-3" data-id="element-87">
              <li data-id="element-88">
                <Link to="/services" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-89">
                  Review Generation
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/services" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-91">
                  GBP Optimization
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/services" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-93">
                  Local SEO
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/services" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-95">
                  Website Setup
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-96">
            <h4 className="text-white font-heading font-bold mb-4" data-id="element-97">Packages</h4>
            <ul className="space-y-3" data-id="element-98">
              <li data-id="element-99">
                <Link to="/pricing" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-100">
                  Starter Plan
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/pricing" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-102">
                  Growth Plan
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/pricing" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-104">
                  Premium Plan
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-105">
            <h4 className="text-white font-heading font-bold mb-4" data-id="element-106">Company</h4>
            <ul className="space-y-3" data-id="element-107">
              <li data-id="element-108">
                <Link to="/about" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-109">
                  About Us
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/careers" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-111">
                  Careers
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/contact" className="text-white/70 hover:text-gold text-sm transition-colors" data-id="element-113">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-114">
          <p className="text-white/50 text-sm" data-id="element-115">
            © {new Date().getFullYear()} Global Remote Agency. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-116">
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-117">
              Privacy Policy
            </a>
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors" data-id="element-118">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}